export default __webpack_public_path__ + "static/media/logo-on-eid.fe2fbad9.png";